import { render, staticRenderFns } from "./WeightBmi.vue?vue&type=template&id=81438460&scoped=true&"
import script from "./WeightBmi.vue?vue&type=script&lang=js&"
export * from "./WeightBmi.vue?vue&type=script&lang=js&"
import style0 from "./WeightBmi.vue?vue&type=style&index=0&id=81438460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81438460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81438460')) {
      api.createRecord('81438460', component.options)
    } else {
      api.reload('81438460', component.options)
    }
    module.hot.accept("./WeightBmi.vue?vue&type=template&id=81438460&scoped=true&", function () {
      api.rerender('81438460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/WeightBmi.vue"
export default component.exports